import {Component} from "preact";
import Toolbar from "../../layout/toolbar";
import SectionComponent from "../../layout/section-component";
import styles from './styles.scss';

export default class CustomInput extends Component {
    static defaultProps = {
        value: '',
        id: null,
        placeholder: '',
        onChange: () => {}
    };

    render(props, state, context) {
        return (
            <Toolbar>
                <input class={styles.input}
                       type={'text'}
                       value={props.value}
                       onInput={props.onChange}
                       placeholder={props.placeholder}
                       id={props.id}
                />
            </Toolbar>
        );
    }
}



// WEBPACK FOOTER //
// ./components/common/custom-input/index.js